<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">Aboutrrrrrrrrrrrr</router-link>
    </div>
    <router-view />
    
  </div>
</template>

<script>
const default_layout = "default";

export default {
  computed:{
    layout() {
      this.getFile();
      //const data = require('./json/test.json');
      //console.log(data);
      return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
  methods: {

  }
}
</script>

<style>

</style>
